import { render, staticRenderFns } from "./moreBuyMoreReward.vue?vue&type=template&id=64fa92c6&scoped=true&"
import script from "./moreBuyMoreReward.vue?vue&type=script&lang=js&"
export * from "./moreBuyMoreReward.vue?vue&type=script&lang=js&"
import style0 from "./moreBuyMoreReward.vue?vue&type=style&index=0&id=64fa92c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fa92c6",
  null
  
)

component.options.__file = "moreBuyMoreReward.vue"
export default component.exports